import { Heading } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnShippingInstructionsTitleEditorRenderer } from "./editor";
import { ReturnShippingInstructionsTitleEmailRenderer } from "./email";
import { ReturnShippingInstructionsTitlePanelRenderer } from "./email-panel";
import type { ReturnShippingInstructionsTitleBlockProps } from "./types";

export default registerBlock<ReturnShippingInstructionsTitleBlockProps>({
  type: "return-shipping-instructions-title",
  name: "editorBlocksLibrary.blocks.return-shipping-instructions-title.title",
  description:
    "editorBlocksLibrary.blocks.return-shipping-instructions-title.description",
  Icon: Heading,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  // The built-in defaults cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnShippingInstructionsTitleEmailRenderer,
      editor: {
        component: ReturnShippingInstructionsTitleEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ReturnShippingInstructionsTitlePanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnShippingInstructionsTitleBlockProps } from "./types";
